<section class="queue">
  <div class="status" [class.live]="mine">
    <span class="badge" [class.on]="mine" aria-hidden="true">{{ mine ? '●' : (waiting ? position : '✓') }}</span>
    <h1>{{ headline }}</h1>
    <p>{{ subhead }}</p>
  </div>

  <div class="bar" *ngIf="mine" role="progressbar" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
    <span [style.width.%]="progress"></span>
  </div>

  <img class="mine-thumb" *ngIf="thumbnail" [src]="thumbnail" alt="Your design" />

  <div class="line" *ngIf="now?.thumbnail || others.length">
    <div class="line-head">
      <h2>The line</h2>
      <button type="button" class="clear-line" *ngIf="canManage && others.length && !confirmingClear"
              (click)="askClear()">Clear the line</button>
      <span class="confirm" *ngIf="canManage && confirmingClear">
        <button type="button" class="confirm-yes" (click)="doClear()">Remove all {{ others.length }}</button>
        <button type="button" class="confirm-no" (click)="cancelClear()">Cancel</button>
      </span>
    </div>

    <div class="row now" *ngIf="now?.thumbnail">
      <img [src]="now.thumbnail" alt="On the board now" />
      <div class="row-text">
        <span class="row-name">{{ now.name || 'Someone\'s design' }}</span>
        <span class="row-sub">{{ secondsLeft > 0 ? 'On for ' + secondsLeft + 's more' : 'Finishing up' }}</span>
      </div>
      <span class="tag live-tag">NOW</span>
    </div>

    <div class="row" *ngFor="let q of others; let i = index; trackBy: trackByKey" [class.mine]="isMine(q)">
      <img [src]="q.thumbnail" *ngIf="q.thumbnail" [alt]="q.name || 'Queued design'" />
      <span class="no-thumb" *ngIf="!q.thumbnail" aria-hidden="true">?</span>
      <div class="row-text">
        <span class="row-name">{{ isMine(q) ? 'Your design' : (q.name || 'Someone\'s design') }}</span>
        <span class="row-sub">{{ i === 0 ? 'Next up' : 'Waiting' }}</span>
      </div>
      <span class="tag" *ngIf="isMine(q)">YOU</span>
      <button type="button" class="drop" *ngIf="canManage" (click)="removeEntry(q)"
              [attr.aria-label]="'Remove ' + (q.name || 'this design') + ' from the line'" title="Remove from the line">✕</button>
    </div>
  </div>

  <div class="save-block" *ngIf="canSave && !finished">
    <label for="queue-save">Save it to the gallery <span class="opt">(optional)</span></label>
    <div class="save-row">
      <input id="queue-save" type="text" placeholder="Name your design" [(ngModel)]="saveName" />
      <button type="button" class="save-btn" [disabled]="!saveName.trim()" (click)="submitSave()">💾 Save</button>
    </div>
  </div>

  <div class="actions">
    <button type="button" class="again" (click)="again.emit()">✏️ Make another</button>
    <button type="button" class="leave" *ngIf="waiting" (click)="leave.emit()">Leave the line</button>
  </div>
</section>
